import { browserHistory } from 'react-router';

export function selectRoute(route) {
  browserHistory.push(`/companies/${route.value}`);
  return {
    type: 'SELECTED_ROUTE',
    selectedRoute: route,
  };
}

export function toggleMobileMenu(isOpen) {
  return {
    type: 'NAVIGATION_ITEMS::TOGGLE_MOBILE_MENU',
    isOpen: !isOpen,
  };
}
